import axios from 'axios';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getStep9SavedColumns = ({shumaId}) => {
  return (dispatch) => {
    const data = {
      shumaID: parseInt(shumaId, 10),
    };

    return axios.post(api.GET_STEP_9_SAVED_COLS, data)
      .then((response) => {
        const {errorCode, body} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);

        const columns = transformBody(body);
        dispatch({
          type: A.SET_STEP_9_GRID_SAVED_COLUMNS,
          payload: columns
        });
      })
      .catch((err) => {
        dispatch({
          type: A.GET_STEP_9_GIRD_SAVED_DATA_FAILURE,
          payload: err.message
        })
      });
  };
};

const transformBody = body => {
  const {
    gridSimilarAssetsColumns,
    gridFirmColumns,
    gridSharedColumns,
    gridTaxAuthorityColumns,
    gridSurveyAssetsColumns,
  } = body;
  return {
    gridSimilarAssetsColumns: gridSimilarAssetsColumns.map(mapColumn),
    gridTaxAuthorityColumns: gridTaxAuthorityColumns.map(mapColumn),
    gridFirmColumns: gridFirmColumns.map(mapColumn),
    gridSharedColumns: gridSharedColumns.map(mapColumn),
    gridSurveyAssetsColumns: gridSurveyAssetsColumns.map(mapColumn)
  };
};

const mapColumn = column => {
  const {display, ...rest} = column;
  return {
    ...rest,
    display: Boolean(display)
  }
};


